/** Resolve the styre console URL: localhost:4301 in dev, else the styre.* sibling domain. */
export function styreappUrl(loc: { hostname: string; protocol: string } = location): string {
  const h = loc.hostname;
  if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:4301';
  return `${loc.protocol}//${h.replace(/^app\./, 'styre.')}`;
}
